import { Menu, Search } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useEntitlements } from '@/lib/entitlements';
import { BrandMark } from './brand-mark';
import { useShell } from './shell-context';

const GHOST = 'text-muted-foreground hover:bg-sidebar-accent/60 hover:text-foreground';

/** Below 768px the sidebar is a drawer, so the shell needs its own header row. */
export function MobileTopBar() {
  const { setMobileNavOpen, setPaletteOpen } = useShell();
  const { enabledModules } = useEntitlements();
  const { pathname } = useLocation();

  const active = enabledModules.find(
    (module) => pathname === module.path || pathname.startsWith(`${module.path}/`),
  );

  return (
    <header className="flex h-12 shrink-0 items-center gap-1 px-2 md:hidden">
      <Button
        variant="ghost"
        size="icon"
        aria-label="Abrir navegación"
        className={GHOST}
        onClick={() => setMobileNavOpen(true)}
      >
        <Menu />
      </Button>

      {active ? (
        <span className="min-w-0 flex-1 truncate px-1 text-sm font-medium">{active.label}</span>
      ) : (
        <BrandMark className="min-w-0 flex-1 px-1" />
      )}

      <Button
        variant="ghost"
        size="icon"
        aria-label="Buscar"
        className={GHOST}
        onClick={() => setPaletteOpen(true)}
      >
        <Search />
      </Button>
    </header>
  );
}
